export default function PollIcon() {
  return (
    <svg
      viewBox="0 0 53 53"
      height="53"
      width="53"
      preserveAspectRatio="xMidYMid meet"
      class=""
      fill="none"
    >
      <circle cx="26.5" cy="26.5" r="26.5" fill="#02A698"></circle>
      <path
        opacity="0.15"
        d="M26.5 0C11.8645 0 0 11.8645 0 26.5H53C53 11.8645 41.1355 0 26.5 0Z"
        fill="#111B21"
      ></path>
      <rect
        x="15.7051"
        y="26.6035"
        width="5.94055"
        height="9.50487"
        rx="1.21053"
        fill="white"
      ></rect>
      <rect
        x="24.0215"
        y="14.7227"
        width="5.94055"
        height="21.386"
        rx="1.21053"
        fill="white"
      ></rect>
      <rect
        x="32.3379"
        y="21.8496"
        width="5.94055"
        height="14.2573"
        rx="1.21053"
        fill="white"
      ></rect>
    </svg>
  );
}
